import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveRadCheckComponent } from '../../shared/components/SaveRadCheck';

export interface CreateRadCheckPageProps {}

const CreateRadCheckPage: React.FC<CreateRadCheckPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_olt);

  return <SaveRadCheckComponent title="Crear registro de Radius" />;
};

export default CreateRadCheckPage;
